<template>
	<div v-if="user">
		<div v-if="user.hasPackage(3)">
			<router-view
				:user="user"
				:isAuth="isAuth">
			</router-view>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
				
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/ProjectsPackage.vue